import { render } from "./Logo.vue?vue&type=template&id=5e737b6a"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
script.render = render

export default script